<template>
    <div>
        <ServiceHeader v-if="initialInfo.statistics" :stats="initialInfo.statistics"/>
        <ServiceBody/>
    </div>
</template>

<script setup>
import ServiceHeader from '@/components/molecule/company/dental-os/single-service/ServiceHeader.vue';
import ServiceBody from '@/components/molecule/company/dental-os/single-service/ServiceBody.vue';
import handleDentalOs from '@/services/modules/dental-os/dentalOs';
import { useRoute } from 'vue-router';
import { onMounted } from 'vue';
import { ref } from 'vue';


const { fetchInitialInfo } = handleDentalOs();
const route = useRoute();
const loading = ref(false);
const initialInfo = ref({});

const getInitialInfo = async () => {
    const query = getQuery();
    loading.value = true

    await fetchInitialInfo(query).then(res => {
        if (!res.status){
            return
        }
        initialInfo.value = res.data;
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
    
}

const getQuery = () => {
    let query = '?company_id=' + route.params.companyId
    return query
}

onMounted(() => {
    getInitialInfo();
})

</script>